window.addEventListener('DOMContentLoaded', function() {

	$(".btnMobile").click(function(){
		if($(".mobile").css("display")=="none") {
          $(".mobile").fadeIn(500);
		} else {
			$(".mobile").fadeOut();
		}
	});

	$('#btnMobile').click(function(){
		$(this).toggleClass("btnClose");
	});

  	$(".btnOpen1").click(function(){
		if($(".boxAbout").css("display")=="none") {
			$(".boxAbout").slideDown(500);
		} else {
			$(".boxAbout").slideUp();
		}
	});
  	$('#btnOpen1').click(function(){
		$(this).toggleClass("btnClose");
	});

  	$(".btnOpen2").click(function(){
		if($(".boxContact").css("display")=="none") {
			$(".boxContact").slideDown(500);
		} else {
			$(".boxContact").slideUp();
		}
	});
  	$('#btnOpen2').click(function(){
		$(this).toggleClass("btnClose");
	});

  	$(".btnOpen3").click(function(){
		if($(".boxMenu").css("display")=="none") {
			$(".boxMenu").slideDown(500);
		} else {
			$(".boxMenu").slideUp();
		}
	});
	$('#btnOpen3').click(function(){
		$(this).toggleClass("btnClose");
	});


  	$(".btnSidebar").click(function(){
		if($(".default-sidebar, .custom-sidebar").css("display")=="none") {
			$(".default-sidebar, .custom-sidebar").slideDown(500);
		} else {
			$(".default-sidebar, .custom-sidebar").slideUp();
		}
	});
  	$('#btnSidebar').click(function(){
		$(this).toggleClass("btnClose");
	});

         
  $(".our-products a.action_button").click(function() {
    let urlData = $(this).attr("data-name");
    let fname = "";
    let lname = "";
    let queryString = fname + "," + lname + "," + urlData;
    $(this).attr("href", "/pages/request-a-quote?datapass=" + queryString);
  });

});

function openmenu1(id1){if($("#child_"+id1).css("display")=="none"){$('#btnDropdown'+id1).html('&ndash;');$("#child_"+id1).slideDown(500);}else{$('#btnDropdown'+id1).html('+');$("#child_"+id1).slideUp();}}